<script setup lang="ts">
defineProps<{
  items: { label: string; value?: string | null }[];
}>();
</script>

<template>
  <div class="submission-meta-grid">
    <div v-for="item in items" :key="item.label" class="submission-meta-grid__item">
      <div class="text-caption text-grey-7">{{ item.label }}</div>
      <div class="text-body2">{{ item.value || '—' }}</div>
    </div>
  </div>
</template>

<style lang="scss">
.submission-meta-grid {
  display: flex;
  flex-direction: row;
  gap: 32px;
  flex-wrap: wrap;

  &__item {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
}
</style>
